import _ from "underscore";

_.mixin({
  // Merges two or more objects starting with the left-most and
  // applying the keys right-word
  // {any:any}* -> {any:any}
  merge() /* objs */ {
    const dest = _.some(arguments) ? {} : null;

    if (dest !== null) {
      _.extend.apply(null, Array.prototype.concat.call([dest], _.toArray(arguments)));
    }

    return dest;
  },

  // Takes an object and a key path like "foo.bar" and returns object.foo.bar.
  getPath(object, key_path) {
    return _.reduce(key_path.split("."), (obj, comp) => (obj ? obj[comp] : obj), object);
  },
});
